import { render, staticRenderFns } from "./ModalConfirmacionReporteCreado.vue?vue&type=template&id=12f26de4&"
import script from "./ModalConfirmacionReporteCreado.vue?vue&type=script&lang=ts&"
export * from "./ModalConfirmacionReporteCreado.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('12f26de4', component.options)
    } else {
      api.reload('12f26de4', component.options)
    }
    module.hot.accept("./ModalConfirmacionReporteCreado.vue?vue&type=template&id=12f26de4&", function () {
      api.rerender('12f26de4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ModalConfirmacionReporteCreado.vue"
export default component.exports